import "chartjs-adapter-moment";
import LineComparison from "./LineComparison";
import BarComparison from "./BarComparison";
import DoughnutComparison from "./DoughnutComparison";
import HistogramComparison from "./HistogramComparison";



function ComparisonGraph({ current, previous, historical = false, res, xInterval, graphType }) {
  return (
    <>
      {
        graphType === "Bar" ? (

          <BarComparison
            xInterval={xInterval}
            res={res}
            previous={previous}
            current={current}

          />
        ) : graphType === "Doughnut" ?

          <DoughnutComparison
            xInterval={xInterval}
            res={res}
            previous={previous}
            current={current}
          />
          : graphType === "Histogram" ? (

            <HistogramComparison
              xInterval={xInterval}
              res={res}
              previous={previous}
              current={current}
              graphType={graphType}

            />

          ) : (
            <LineComparison

              xInterval={xInterval}
              res={res}
              previous={previous}
              current={current}
              graphType={graphType}
            />
          )


      }


    </>
  );
}

export default ComparisonGraph;
